var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRecoilValue } from 'recoil';
import { appErrorState } from '../../../Domain/State/AppState';
export function ErrorInformation(_a) {
    var title = _a.title;
    var error = useRecoilValue(appErrorState);
    return ((error.message && error.message !== '')
        ? _jsx("div", __assign({ className: "form-page" }, { children: _jsx("div", __assign({ className: "fields row" }, { children: _jsxs("div", __assign({ className: "field field--text col col-12 col-md-12" }, { children: [_jsx("label", { children: title }), _jsx("div", __assign({ className: "field__text" }, { children: error.message }))] })) })) }))
        : _jsx(_Fragment, {}));
}
